import { _ImageFormat } from './../../enumerator';
export class _ImageDecoder {
    constructor() {
        this._format = _ImageFormat.unknown;
        this._height = 0;
        this._width = 0;
        this._bitsPerComponent = 8;
        this._position = 0;
        this._noOfComponents = -1;
    }
    _reset() {
        this._position = 0;
    }
    _getBuffer(index) {
        return this._stream[index];
    }
    _read(buffer, offset, count, stream) {
        if (stream && Array.isArray(stream)) {
            let result = 0;
            if (count <= stream.length && stream.length - offset >= count) {
                for (let i = 0; i < count; i++) {
                    buffer[i] = stream[offset];
                    offset++;
                    result++;
                }
            }
            return { 'outputBuffer': buffer, 'offset': offset, 'length': result };
        }
        else {
            for (let index = offset; index < count; index++) {
                const position = this._position;
                buffer[index] = this._getBuffer(position);
                this._position++;
            }
        }
    }
    _readString(length) {
        let result = '';
        for (let i = 0; i < length; i++) {
            result += String.fromCharCode(this._readByte());
        }
        return result;
    }
    _seek(length) {
        this._position += length;
    }
    _readByte() {
        if (this._position < this._stream.byteLength) {
            const value = this._getBuffer(this._position);
            this._position += 1;
            return value;
        }
        else {
            throw new Error('Error decoding JPEG image. Invalid offset.');
        }
    }
    _toUnsigned16(value) {
        value = value & 0xFFFF;
        return value < 0 ? (value + 0x10000) : value;
    }
    _readUnsigned32(offset) {
        const i1 = this._getBuffer(offset + 3);
        const i2 = this._getBuffer(offset + 2);
        const i3 = this._getBuffer(offset + 1);
        const i4 = this._getBuffer(offset);
        return i1 | (i2 << 8) | (i3 << 16) | (i4 << 24);
    }
}
